// extracted by mini-css-extract-plugin
export var chevron = "_p3-1";
export var clickable = "_p3-0";
export var ruleRow = "_p3-2";